
import { GALLERY_CATEGORY_ADD_ITEM, GALLERY_CATEGORY_DELETE, GALLERY_CATEGORY_UPDATE, GET_ALL_GALLERY, GET_ALL_GALLERY_CATEGORY, GET_ALL_GALLERY_FAILED, GET_ALL_GALLERY_SUCCESS, GET_ALL_UNSPLASH_ITEMS } from '../../constants/galleryConstant';

const initialState = {
    galleryData: {
        data: [],
        pagination: {
            page: 1
        }
    },
    category: {
        data: [],
        pagination: {}
    },
    unsplashData: {
        data: [],
        pagination: {
            page: 1
        }
    },
    isLoading: false,
    error: null
};

export default function galleryReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_GALLERY:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case GET_ALL_GALLERY_SUCCESS:
            const isFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                galleryData: {
                    data: isFirstPage
                        ? action.payload.data
                        : [...state.galleryData.data, ...action.payload.data],
                    pagination: action.payload.pagination
                }
            };

        case GET_ALL_UNSPLASH_ITEMS:
            const isFirstUnsPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                unsplashData: {
                    data: isFirstUnsPage
                        ? (action.payload.data && action.payload.data.length > 0 ? action.payload.data : [])
                        : [...state.unsplashData.data, ...(action.payload.data && action.payload.data.length > 0 ? action.payload.data : [])],
                    pagination: action.payload.pagination
                }
            };

        case GET_ALL_GALLERY_CATEGORY:
            const isCatFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                category: {
                    data: isCatFirstPage
                        ? action.payload.data
                        : [...state.category.data, ...action.payload.data],
                    pagination: action.payload.pagination
                }
            };
        case GALLERY_CATEGORY_ADD_ITEM: {
            const categoryId = action.payload.catId;
            const categoryItem = action.payload.item;
            return {
                ...state,
                category: {
                    ...state.category,
                    data: state.category.data.map(item =>
                        item.id === categoryId
                            ? {
                                ...item,
                                items: item.items ?
                                    item.items.some(existingItem => existingItem.id === categoryItem.id)
                                        ? item.items
                                        : [...item.items, categoryItem]
                                    : [categoryItem],
                                itemCount: (item.items && item.items.some(existingItem => existingItem.id === categoryItem.id))
                                    ? item.itemCount
                                    : (item.itemCount || 0) + 1
                            }
                            : item
                    )
                },
                isLoading: false
            };
        }
        case GALLERY_CATEGORY_DELETE: {
            const categoryId = action.payload.catId;
            return {
                ...state,
                category: {
                    ...state.category,
                    data: state.category.data.filter(item => item.id !== categoryId) // Filter out the category with the matching ID
                },
                isLoading: false
            };
        }
        case GALLERY_CATEGORY_UPDATE: {
            const categoryId = action.payload.catId;
            const updatedTitle = action.payload.title;
            const updatedData = [action.payload.data];

            return {
                ...state,
                category: {
                    ...state.category,
                    data: (!Array.isArray(state.category.data) || state.category.data.length === 0)
                        ? updatedData
                        : state.category.data.map(item =>
                            item.id === categoryId ? { ...item, title: updatedTitle } : item
                        )
                },
                isLoading: false
            };
        }

        case GET_ALL_GALLERY_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        default:
            return state;
    }
}